import breakpoints from './breakpoints'

export default breakpoints
